import { supabase } from "../../../app/supabaseClient";
import supabaseApi from "../supabaseSlice";

const categoriesApi = supabaseApi.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query({
      queryFn: async () => {
        const { data, error } = await supabase
          .from("categories")
          .select("*")
          .order("order");
        if (error) throw { error };
        return { data };
      },
    }),
    getCategory: build.query({
      queryFn: async (id) => {
        const { data, error } = await supabase
          .from("categories")
          .select("*")
          .eq("id", id)
          .single();
        if (error) throw { error };
        return { data };
      },
    }),
    createCategory: build.mutation({
      queryFn: async (category) => {
        const { data, error } = await supabase
          .from("categories")
          .upsert(category);
        if (error) throw { error };
        return { data };
      },
    }),
    deleteCategory: build.mutation({
      queryFn: async (id) => {
        const { data, error } = await supabase
          .from("categories")
          .delete()
          .eq("id", id);
        if (error) throw { error };
        return { data };
      },
    }),
  }),
});

export const {
  useGetCategoryQuery,
  useCreateCategoryMutation,
  useGetCategoriesQuery,
  useDeleteCategoryMutation,
} = categoriesApi;
